import React from 'react';
import { useConnect } from '@lore/query-connect';
import { event_networkId } from '../../../../utils/query-helpers';

export default function useInvitationsReal(state, network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          // ...event_networkId(network),
          event: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        },
        $eager: eager
      }
    },
    pagination: {
      pageSize: 1000
    }
  });
}
